import React, { useEffect, useState } from 'react';
import { ImageSourcePropType, ViewProps } from 'react-native';
import styled from 'styled-components/native';
import api from '../api/api';
import { User } from '../models/User';
import { log } from '../tools/LogHelper';
import { stringify } from 'flatted';

const AvatarView = styled.View<AvatarProps>`
  width: ${p => p.size}px;
  height: ${p => p.size}px;
  border-radius: ${p => p.size}px;
  background-color: #fff;
  align-items: center;
  justify-content: center;
` as React.FC<AvatarProps>;

const AvatarImage = styled.Image<AvatarProps>`
  width: ${p => p.size as number}px;
  height: ${p => p.size as number}px;
  border-radius: ${p => p.size as number}px;
`;

export type AvatarProps = ViewProps & {
  size?: 'hero' | 'large' | 'medium' | 'small' | number;
  source?: ImageSourcePropType;
  user?: User | null;
};

// eslint-disable-next-line
const defaultAvatarImage = require('../assets/silhouette.png');

const Avatar: React.FC<AvatarProps> = ({ size, source, user, ...props }) => {
  const userId = user?.id;
  size = (() => {
    if (typeof size === 'number') return size;
    switch (size) {
      case 'hero':
        return 132;
      case 'large':
        return 80;
      case 'small':
        return 35;
      case 'medium':
      default:
        return 50;
    }
  })();
  const [imageUri, setImageUri] = useState('');
  useEffect(() => {
    if (!userId) {
      setImageUri('');
      return;
    }
    (async () => {
      try {
        const accessToken = await api.getAccessToken();
        const url = user.mediumUrl;
        if (url) {
          const querySpacing = url.includes('?') ? '&' : '?';
          const response = await fetch(
            `${url}${querySpacing}token=${accessToken}`
          );
          if (response.status === 200) {
            const blob = await response.blob();
            const dataUri = await blobToBase64(blob);
            setImageUri(dataUri);
          }
        }
      } catch (error) {
        log(stringify(error));
      }
    })();
  }, [user, userId]);
  return (
    <AvatarView size={size} {...props}>
      <AvatarImage
        size={size}
        source={
          imageUri ? { uri: imageUri } : source ? source : defaultAvatarImage
        }
      />
    </AvatarView>
  );
};

export default Avatar;

function blobToBase64(blob: Blob) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      }
      reject('Not a data uri');
    };
    reader.readAsDataURL(blob);
  });
}
